import {
    DELETE_AREA_EXECUTIVE_REQUEST,
    DELETE_AREA_EXECUTIVE_SUCCESS,
    DELETE_AREA_EXECUTIVE_FAILURE
} from "../actions/types";

const initialState = {
    isDeleting: false,
    deleteSuccess: false,
    deleteError: null,
};

export const deleteAreaExecutiveReducer = (state = initialState, action) => {
    switch (action.type) {
        case DELETE_AREA_EXECUTIVE_REQUEST:
            return {
                ...state,
                isDeleting: true,
                deleteSuccess: false,
                deleteError: null,
            };

        case DELETE_AREA_EXECUTIVE_SUCCESS:
            return {
                ...state,
                isDeleting: false,
                deleteSuccess: true,
                deleteError: null,
            };

        case DELETE_AREA_EXECUTIVE_FAILURE:
            return {
                ...state,
                isDeleting: false,
                deleteSuccess: false,
                deleteError: action.payload,
            };

        default:
            return state;
    }
};
